/** @format */

import React, { useState } from 'react';
import {
  Grid,
  IconButton,
  Button,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Paper,
} from '@mui/material';
import { InputV2, SelectV, SimpleDialog, Icons } from 'components';
import { useFieldArray, useForm, useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import { useStyles } from './Style';

const HeaderParameters = (props) => {
  const methods = useFormContext();
  const classes = useStyles();
  const [editRowSelected, setEditRowSelected] = useState(-1);
  const { register, formState: { errors }, trigger, control, getValues, reset } = useForm({
    mode: 'onChange',
  });

  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: 'scHeaderParams',
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [indexSelected, setIndexSelected] = useState(-1);

  const removeRow = (index) => {
    setIndexSelected(index);
    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button onClick={confirmRemove} variant="contained" color="primary">
          تایید
        </Button>
        <Button onClick={closeDialog} variant="contained">
          انصراف
        </Button>
      </>
    );
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const confirmRemove = () => {
    setOpenDialog(false);
    remove(indexSelected);
    setIndexSelected(-1);
  };

  const addRow = async () => {
    const valid = await trigger(['parameterName', 'parameterDefaultValue', 'parameterDesc']);

    if (valid) {
      const rowValues = {
        scParameterName: getValues('parameterName'),
        scProviderParameterName: getValues('providerParameterName'),
        scParameterDesc: getValues('parameterDesc'),
        scParameterLogMode: getValues('parameterLogMode'),
        typeOfInput: getValues('typeOfInput'),
        scParameterDefaultValue: getValues('parameterDefaultValue'),
      };
      append(rowValues);
      reset({});
    }
  };

  const editRow = (index) => {
    setEditRowSelected(index);
  };

  const saveRow = (index) => {
    setEditRowSelected(-1);
  };

  const typeOfInput = {
    optional: 'اختیاری',
    required: 'اجباری',
    hidden: 'مخفی',
  };

  return (
    <>
      <SimpleDialog
        title="حذف پارامتر Header"
        content="آیا از حذف پارامتر اطمینان دارید؟"
        open={openDialog}
        actions={<ActionsBtn />}
      />
      {/* scIsRequired */}
      {/* scHiddenParameter */}
      <Grid container direction="row" alignItems="center" spacing={3}>
        {/* This block will be ignored when submitting the form. */}
        <Grid container item xs={12} spacing={3} alignItems="center">
          <Grid item xs={2}>
            <InputV2
              label="نام پارامتر"
              fullWidth
              errors={errors}
              name="parameterName"
              register={register}
              rules={['required']}
              control={control}
              hasMargin={false}
            />
          </Grid>

          <Grid item xs={2}>
            <InputV2
              label="نام مستعار"
              fullWidth
              errors={errors}
              name="providerParameterName"
              register={register}
              rules={['required']}
              control={control}
              hasMargin={false}
            />
          </Grid>

          <Grid item xs={1}>
            <InputV2
              label="شرح"
              fullWidth
              errors={errors}
              name="parameterDesc"
              register={register}
              rules={['required']}
              control={control}
              hasMargin={false}
            />
          </Grid>

          <Grid item xs={2}>
            <SelectV
              label="وضعیت لاگ"
              name="parameterLogMode"
              options={[
                { value: 'LOGGABLE', label: 'LOGGABLE' },
                { value: 'NOT_LOGGABLE', label: 'NOT_LOGGABLE' },
                { value: 'MASK', label: 'MASK' },
              ]}
              control={control}
              rules={['required']}
              errors={errors}
              fullWidth
              defaultValue="LOGGABLE"
            />
          </Grid>

          <Grid item xs={2}>
            <SelectV
              label="نوع ورودی"
              name="typeOfInput"
              options={[
                { value: 'optional', label: 'اختیاری' },
                { value: 'required', label: 'اجباری' },
                { value: 'hidden', label: 'مخفی' },
              ]}
              control={control}
              rules={['required']}
              errors={errors}
              fullWidth
              defaultValue="optional"
            />
          </Grid>

          <Grid item xs={2}>
            <InputV2
              label="مقدار پیش فرض"
              fullWidth
              errors={errors}
              name="parameterDefaultValue"
              register={register}
              rules={['required']}
              control={control}
              hasMargin={false}
            />
          </Grid>

          <Grid item xs={1}>
            <Button color="primary" variant="outlined" onClick={addRow} style={{ marginTop: 16 }}>
              افزودن
            </Button>
          </Grid>
        </Grid>
        {fields.length > 0 && (
          <Grid item xs={12}>
            <Box mt={3}>
              <TableContainer component={Paper} className={classes.table}>
                <Table>
                  <TableHead style={{ backgroundColor: '#eef1f5' }}>
                    <TableRow>
                      <TableCell>نام پارامتر</TableCell>
                      <TableCell>نام مستعار</TableCell>
                      <TableCell>شرح</TableCell>
                      <TableCell>لاگ وضعیت</TableCell>
                      <TableCell>نوع ورودی</TableCell>
                      <TableCell>پیش فرض</TableCell>
                      <TableCell>عملیات</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fields.map((field, index) => {
                      return (
                        <TableRow key={field.id}>
                          {/* scParameterName */}
                          <TableCell>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected === index,
                              })}
                            >
                              {field.scParameterName}
                            </span>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected !== index,
                              })}
                            >
                              <InputV2
                                fullWidth
                                errors={methods.formState.errors}
                                name={`scHeaderParams[${index}].scParameterName`}
                                register={methods.register}
                                rules={['required']}
                                control={methods.control}
                                defaultValue={field.scParameterName}
                              />
                            </span>
                          </TableCell>

                          {/* scProviderParameterName */}
                          <TableCell>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected === index,
                              })}
                            >
                              {field.scProviderParameterName}
                            </span>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected !== index,
                              })}
                            >
                              <InputV2
                                fullWidth
                                errors={methods.formState.errors}
                                name={`scHeaderParams[${index}].scProviderParameterName`}
                                register={methods.register}
                                rules={['required']}
                                control={methods.control}
                                defaultValue={field.scProviderParameterName}
                              />
                            </span>
                          </TableCell>

                          {/* scParameterDesc */}
                          <TableCell>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected === index,
                              })}
                            >
                              {field.scParameterDesc}
                            </span>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected !== index,
                              })}
                            >
                              <InputV2
                                fullWidth
                                errors={methods.formState.errors}
                                name={`scHeaderParams[${index}].scParameterDesc`}
                                register={methods.register}
                                rules={['required']}
                                control={methods.control}
                                defaultValue={field.scParameterDesc}
                              />
                            </span>
                          </TableCell>

                          {/* scParameterLogMode */}
                          <TableCell>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected === index,
                              })}
                            >
                              {field.scParameterLogMode}
                            </span>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected !== index,
                              })}
                            >
                              <SelectV
                                label="وضعیت لاگ"
                                name={`scHeaderParams[${index}].scParameterLogMode`}
                                options={[
                                  { value: 'LOGGABLE', label: 'LOGGABLE' },
                                  { value: 'NOT_LOGGABLE', label: 'NOT_LOGGABLE' },
                                  { value: 'MASK', label: 'MASK' },
                                ]}
                                control={methods.control}
                                rules={['required']}
                                errors={methods.formState.errors}
                                fullWidth
                                defaultValue={field.scParameterLogMode}
                                margin="dense"
                              />
                            </span>
                          </TableCell>

                          {/* typeOfInput */}
                          <TableCell>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected === index,
                              })}
                            >
                              {typeOfInput[field.typeOfInput]}
                            </span>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected !== index,
                              })}
                            >
                              <SelectV
                                label="نوع ورودی"
                                name={`scHeaderParams[${index}].typeOfInput`}
                                options={[
                                  { value: 'optional', label: 'اختیاری' },
                                  { value: 'required', label: 'اجباری' },
                                  { value: 'hidden', label: 'مخفی' },
                                ]}
                                control={methods.control}
                                rules={['required']}
                                errors={methods.formState.errors}
                                fullWidth
                                defaultValue={field.typeOfInput}
                                margin="dense"
                              />
                            </span>
                          </TableCell>

                          {/* scParameterDefaultValue */}
                          <TableCell>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected === index,
                              })}
                            >
                              {field.scParameterDefaultValue}
                            </span>
                            <span
                              className={clsx({
                                [classes.hiddenRow]: editRowSelected !== index,
                              })}
                            >
                              <InputV2
                                fullWidth
                                errors={methods.formState.errors}
                                name={`scHeaderParams[${index}].scParameterDefaultValue`}
                                register={methods.register}
                                rules={['required']}
                                control={methods.control}
                                defaultValue={field.scParameterDefaultValue}
                              />
                            </span>
                          </TableCell>

                          <TableCell align="right" style={{ width: 150 }}>

                            {editRowSelected === index ? (
                              <IconButton
                                variant="contained"
                                color="primary"
                                onClick={() => saveRow(index)}
                                size="large">
                                <Icons icon='save' color='#2B3990' size='25' />
                              </IconButton>
                            ) : (
                              <IconButton
                                variant="contained"
                                color="primary"
                                onClick={() => editRow(index)}
                                size="large">
                                <Icons icon='editPen' color='#2B3990' size='20' />

                              </IconButton>
                            )}
                            <IconButton
                              variant="contained"
                              color="primary"
                              aria-label="delete"
                              onClick={() => removeRow(index)}
                              size="large">
                              <Icons icon='Trash' color='#2B3990' size='23' />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default HeaderParameters;
